import { useMemo, useState } from 'react';
import cm from 'classnames';

import { RenderStatus } from 'services/finalcut.service';
import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import { downloadFinalcut } from 'components/app/_mediator/app-files-upload.slice';

import { ReactComponent as DownloadIco } from 'assets/ui/download-file.svg';

import { Loader } from 'components/UI/loader/loader';
import { AppButton } from 'components/app/app-components/app-button/app-button';
import { IntroKeys } from 'components/app/intro/intro-keys';
import styles from './_fc-download.module.scss';

export const FcDownload = () => {
  const { id, name, url, fcStatus } = useAppSelector((state) => state.fc__data);
  const finalcutDownloads = useAppSelector((state) => state.app__filesUpload.finalcutDownloads);
  const dispatch = useAppDispatch();

  const [isDownloading, setDownloading] = useState(false);

  const isDisabled = useMemo(() => {
    return fcStatus !== RenderStatus.rendered;
  }, [fcStatus]);

  const progress = useMemo(() => {
    if (!id || !finalcutDownloads[id]) return null;
    return finalcutDownloads[id];
  }, [id && finalcutDownloads[id]]);

  const downloadAndSaveFile = async () => {
    if (!id || !url || !name) return;
    setDownloading(true);
    await dispatch(downloadFinalcut({ fcId: id, url, fileName: name }))
      .unwrap()
      .finally(() => setTimeout(() => setDownloading(false), 1000));
  };

  return (
    <AppButton
      disabled={isDisabled || isDownloading}
      onClick={downloadAndSaveFile}
      outlined
      className={cm(styles.FcDownload, { [styles.disabled]: isDisabled })}
      data-intro={IntroKeys.fcDownload}
      tip="Download final cut"
      tipPosition="bottom"
    >
      {!progress ? (
        isDownloading ? (
          <Loader className={styles.FcDownload__Loader} />
        ) : (
          <DownloadIco />
        )
      ) : (
        <div
          className={styles.FcDownload__progress}
          style={
            {
              '--progress': `${progress}%`,
            } as React.CSSProperties
          }
        >
          <span>{progress ?? 0}%</span>
        </div>
      )}
    </AppButton>
  );
};
